<div class="full-size-image-wrap"
     (click)="close()">
  <div class="full-size-image-content"
       (click)="$event.stopPropagation()">
    <i class="icon-close pointer"
       (click)="close()"></i>

    <img [src]="imgUrl">
  </div>
</div>
